// src/app/AuthGuard.tsx
import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { verifySession } from "@/api/auth";
import { APP_ROUTES } from "@/api/constants";
import PlaneLoadingScreen from "@/components/shared/ui/PageLoadingScreen";

export default function AuthGuard() {
  const location = useLocation();
  const [status, setStatus] =
    useState<"checking" | "ok" | "redirect">("checking");

  useEffect(() => {
    let cancelled = false;

    verifySession()
      .then(() => {
        if (!cancelled) setStatus("ok");
      })
      .catch(() => {
        if (!cancelled) setStatus("redirect");
      });

    return () => {
      cancelled = true;
    };
  }, []);

  if (status === "checking") {
    return (
      <PlaneLoadingScreen
        fullscreen
        // label="Checking your session..."
      />
    );
  }

  if (status === "redirect") {
    return (
      <Navigate
        to={APP_ROUTES.login}
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }

  return <Outlet />;
}
